import { RootPage, RootPageTransparentPaper } from "@app/components/RootPage";
import { RootPageHeader } from "@app/components/RootPageHeader";
import { usePortfolioGroupInfo } from "../usePortfolioGroupInfo";
import { usePortfolioGroupParams } from "@app/hooks/usePortfolioGroupParams";
import { viewPortfolioGroupPages } from "@app/const/route.const";
import { SourceDataAsOf } from "../SourceDataAsOf";
import { CarModuleSectionCode } from "@app/hooks/useUserAccess";
import { AccessRouteControl } from "@app/components/AccessRouteControl";
import { EditPortfolioGroupAnalyze } from "../editPortfolioGroup/EditPortfolioGroupAnalyze";
import { ViewPortfolioGroupSummary } from "./ViewPortfolioGroupSummary";
import { Box } from "@mui/material";
import { CarNavigateButton } from "@app/components/NavigateButton";
import { ReactElement } from "react";

export const ViewPortfolioGroupPage = () => {
  const { portfolioGroupId } = usePortfolioGroupParams();
  const groupInfo = usePortfolioGroupInfo({ portfolioGroupId });

  const withNextButton = (page: ReactElement) => (nextPageUrl: string) => (
    <>
      {page}
      <Box
        sx={{
          mt: "auto",
          display: "flex",
          gap: 2.5,
          justifyContent: "center",
        }}
      >
        <CarNavigateButton
          sx={{ mt: 5, fontSize: "18px" }}
          url={`..\\${nextPageUrl}`}
        >
          Next
        </CarNavigateButton>
      </Box>
    </>
  );

  return (
    <RootPage sx={{ backgroundColor: "white" }}>
      <RootPageHeader
        isSmall
        title={`View - ${groupInfo.title}`}
        isLoading={groupInfo.isLoading}
        items={[
          {
            label: "Summary",
            url: viewPortfolioGroupPages.summary,
            moduleSection: CarModuleSectionCode.ANALYZE_PORTFOLIO_GROUP_PUBLISH,
          },
          {
            label: "Analyze",
            url: viewPortfolioGroupPages.analyze,
            moduleSection: CarModuleSectionCode.ANALYZE_PORTFOLIO_GROUP_ANALYZE,
          },
        ]}
      />
      <RootPageTransparentPaper>
        <SourceDataAsOf />
        <AccessRouteControl
          items={[
            {
              path: viewPortfolioGroupPages.summary,
              element: withNextButton(<ViewPortfolioGroupSummary />)(
                viewPortfolioGroupPages.analyze,
              ),
              moduleSection: CarModuleSectionCode.VIEW_PORTFOLIO_GROUP_SUMMARY,
            },
            {
              path: viewPortfolioGroupPages.analyze,
              element: <EditPortfolioGroupAnalyze isReadOnly />,
              moduleSection: CarModuleSectionCode.VIEW_PORTFOLIO_GROUP_ANALYZE,
            },
          ]}
          defaultPath={viewPortfolioGroupPages.summary}
        />
      </RootPageTransparentPaper>
    </RootPage>
  );
};
